export default __webpack_public_path__ + "static/media/filezip.8bb96dc4.svg";